// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
  border: 1px solid var(--app-mid-lighter-2);
  --border-radius: 5px;
  border-radius: 5px;
  padding: 0;
  --box-shadow: none;
}

.page .input-field-wrap .input-field, .page .input-fields-vModal_alarm.input-fields--text .input-field, .page .template_emails-push .input-email .input-field, .page .input-field-wrap .input-field-lg {
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --padding-start: 8px;
  --padding-end: 8px;
}

.page .input-field-wrap .input-field-lg {
  --padding-top: 12px;
  --padding-bottom: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
}

.pg-footer {
  border-top: 1px solid var(--app-mid-lighter-2);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.pg-footer .foot-btn {
  margin: 0;
  font-weight: 600;
}
.pg-footer .foot-btn.mw-120 {
  min-width: 120px;
}
.pg-footer::before {
  content: normal;
}

.pg-header {
  padding: 15px 20px;
  background-color: var(--app-main-darker);
}
.pg-header .head-elem.he-title {
  margin-bottom: 20px;
}
.pg-header .head-elem.he-title.mb-0 {
  margin-bottom: 0;
}
.p-20.pg-header {
  padding: 20px 20px;
}

.page .input-field-wrap.w-stacked-lbl .input-field-lbl, .page .input-lbl, .page .recap-grid .output-val, .page .recap-grid-type2 .output-val, .page .template_emails-push .emails .email .text {
  word-break: break-all;
  word-break: break-word;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.page {
  padding: 20px 20px 50px;
}
.page .btnbar {
  display: flex;
  justify-content: center;
}
.page .btnbar .el-btn {
  margin: 0;
  font-weight: 600;
}
.page .btnbar .el-btn.mw-180 {
  min-width: 180px;
}
.page .btnbar .el-btn:not(:last-child).mr-25 {
  margin-right: 25px;
}
.page .btnbar.mt-40 {
  margin-top: 40px;
}
.page .checkboxes {
  padding-top: 15px;
}
.page .checkboxes.pt-5 {
  padding-top: 5px;
}
.page .description {
  color: var(--app-mid-dark);
}
.page .description .b {
  font-weight: 600;
}
.page .description .b.uppercase {
  text-transform: uppercase;
}
.page .description.lh-13 {
  line-height: 1.3;
}
.page .description.mb-20 {
  margin-bottom: 20px;
}
.page .description.pt-10 {
  padding-top: 10px;
}
.page .images-cart {
  display: flex;
  justify-content: center;
}
.page .images-cart .img-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.page .images-cart .img-panel .ip-num {
  margin-bottom: 5px;
  color: var(--app-main);
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}
.page .images-cart .img-panel .ip-img-wrap {
  flex: 1;
  border: 1px solid var(--app-mid-lighter-2);
}
.page .images-cart .img-panel .ip-img-wrap .ip-img {
  vertical-align: middle;
}
.page .images-cart .img-panel:not(:last-child) {
  padding-right: 30px;
}
.page .images-cart.mt-20 {
  margin-top: 20px;
}
.page .images-cart.mt-25 {
  margin-top: 25px;
}
.page .input-field-wrap {
  display: flex;
  align-items: center;
}
.page .input-field-wrap .input-field {
  max-width: 300px;
}
.page .input-field-wrap .input-field.ml-20 {
  margin-left: 20px;
}
.page .input-field-wrap .input-field.mxw-250 {
  max-width: 250px;
}
.page .input-field-wrap .input-field.mxv-100p, .page .input-field-wrap .input-field.mxv100p {
  max-width: 100%;
}
.page .input-field-wrap .input-field-lg.fz-15 {
  font-size: 15px;
}
.page .input-field-wrap .input-field-lg.mxv-100p, .page .input-field-wrap .input-field-lg.mxv100p {
  max-width: 100%;
}
.page .input-field-wrap .input-field-lg.mxw-300 {
  max-width: 300px;
}
.page .input-field-wrap .input-field-lg.mxw-350 {
  max-width: 350px;
}
.page .input-field-wrap .input-field-lg.readonly {
  border: 0;
}
.page .input-field-wrap .input-help {
  margin-left: 12px;
  color: var(--app-main-softer);
  font-size: 22px;
}
.page .input-field-wrap .input-help.ml-15 {
  margin-left: 15px;
}
.page .input-field-wrap .input-help.ml-20 {
  margin-left: 20px;
}
.page .input-field-wrap .input-unit {
  margin-left: 12px;
  color: rgba(var(--app-mid-rgb), 0.7);
  font-size: 14px;
  font-weight: 500;
}
.page .input-field-wrap.w-stacked-lbl {
  flex-direction: column;
  align-items: flex-start;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl {
  color: var(--app-mid-dark);
  font-size: 14px;
  font-weight: 500;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-0 {
  margin-bottom: 0;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-5 {
  margin-bottom: 5px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-10 {
  margin-bottom: 10px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-15 {
  margin-bottom: 15px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-20 {
  margin-bottom: 20px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-25 {
  margin-bottom: 25px;
}
.page .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-30 {
  margin-bottom: 30px;
}
.page .input-field-wrap:not(:last-child) {
  margin-bottom: 20px;
}
.page .input-field-wrap.mb-0 {
  margin-bottom: 0;
}
.page .input-field-wrap.mb-5 {
  margin-bottom: 5px;
}
.page .input-field-wrap.mb-10 {
  margin-bottom: 10px;
}
.page .input-field-wrap.mb-15 {
  margin-bottom: 15px;
}
.page .input-field-wrap.mb-20 {
  margin-bottom: 20px;
}
.page .input-field-wrap.mb-25 {
  margin-bottom: 25px;
}
.page .input-field-wrap.mb-30 {
  margin-bottom: 30px;
}
.page .input-field-wrap.mxw-350 {
  max-width: 350px;
}
.page .input-fields-vModal_alarm {
  display: flex;
  flex-wrap: wrap;
}
.page .input-fields-vModal_alarm.input-fields--check {
  margin: -8px -10px 0;
}
.page .input-fields-vModal_alarm.input-fields--check .input-field.special {
  margin-left: 15px;
}
.page .input-fields-vModal_alarm.input-fields--text {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 250px));
  gap: 10px 30px;
}
.page .input-fields-vModal_alarm.input-fields--toggle {
  margin: -10px -20px 0;
}
.page .input-fields-vModal_alarm:not(:last-child) {
  margin-bottom: 20px;
}
.page .input-lbl {
  margin-bottom: 15px;
  color: var(--app-mid);
  font-size: 18px;
  font-weight: 500;
}
.page .input-lbl.input-lbl--mid-dark {
  color: var(--app-mid-dark);
}
.page .input-lbl.fz-14 {
  font-size: 14px;
}
.page .input-lbl.fz-15 {
  font-size: 15px;
}
.page .input-lbl.fz-16 {
  font-size: 16px;
}
.page .input-lbl.fz-17 {
  font-size: 17px;
}
.page .input-lbl.fz-19 {
  font-size: 19px;
}
.page .input-lbl.fz-20 {
  font-size: 20px;
}
.page .input-lbl.mb-0 {
  margin-bottom: 0;
}
.page .input-lbl.mb-5 {
  margin-bottom: 5px;
}
.page .input-lbl.mb-10 {
  margin-bottom: 10px;
}
.page .input-lbl.mb-15 {
  margin-bottom: 15px;
}
.page .input-lbl.mb-20 {
  margin-bottom: 20px;
}
.page .input-lbl.mb-25 {
  margin-bottom: 25px;
}
.page .input-lbl.mb-30 {
  margin-bottom: 30px;
}
.page .recap-grid {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px 25px;
  justify-content: center;
}
.page .recap-grid .input-lbl {
  grid-column: 1/3;
  margin-bottom: 8px;
}
.page .recap-grid .output-lbl {
  color: var(--app-mid-light);
  font-size: 17px;
  font-weight: 500;
}
.page .recap-grid .output-val {
  color: var(--app-mid-dark);
  font-size: 17px;
  font-weight: 500;
}
.page .recap-grid.mw-75p {
  margin: 0 auto;
  max-width: 75%;
}
.page .recap-grid-type2 {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px 25px;
}
.page .recap-grid-type2 .hr {
  margin: 5px 0;
  grid-column: 1/3;
  height: 1px;
  background-color: var(--app-mid-lighter-2);
}
.page .recap-grid-type2 .input-lbl {
  margin-bottom: 20px;
  grid-column: 1/3;
  font-size: 16px;
}
.page .recap-grid-type2 .output-lbl {
  color: var(--app-mid-dark);
  font-size: 15px;
  font-weight: 500;
}
.page .recap-grid-type2 .output-val {
  justify-self: flex-end;
  color: var(--app-mid-light);
  font-size: 15px;
  font-weight: 500;
}
.page .recap-grid-type2 .rg-btn {
  margin: 0;
}
.page .recap-grid-type2 .rg-btn.rg-btn--confirm {
  margin-top: 30px;
  grid-column: 1/3;
  justify-self: center;
  --padding-start: 25px;
  --padding-end: 25px;
  font-weight: 600;
}
.page .searchbar {
  max-width: 350px;
}
.page .select-item {
  display: flex;
  align-items: center;
}
.page .select-item .sp-lbl {
  margin-right: 20px;
  color: var(--app-mid-dark);
  font-weight: 500;
}
.page .select-item .sp-input.mxw-150 {
  max-width: 150px;
}
.page .select-item .sp-btn {
  margin: 0;
  margin-left: 12px;
  --border-radius: 50%;
  --padding-top: 6px;
  --padding-bottom: 6px;
  --padding-start: 6px;
  --padding-end: 6px;
  height: auto;
}
.page .select-item .sp-btn .btn-icon {
  font-size: 20px;
}
.page .template_emails-push {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, auto));
  gap: 25px 40px;
}
.page .template_emails-push .input-email {
  display: flex;
  align-items: center;
}
.page .template_emails-push .input-email .input-field {
  margin-right: 12px;
}
.page .template_emails-push .input-email .btn-add {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 8px;
  --padding-end: 8px;
  height: auto;
  font-size: 9px;
}
.page .template_emails-push .emails {
  padding-top: 10px;
}
.page .template_emails-push .emails .email {
  display: flex;
  align-items: center;
}
.page .template_emails-push .emails .email .text {
  margin-top: -1px;
  margin-right: 15px;
  color: var(--app-mid-dark);
  font-size: 17px;
  line-height: 20px;
  font-weight: 500;
  max-height: calc(2 * 20px);
  overflow-y: hidden;
}
.page .template_emails-push .emails .email .btn-close {
  margin: 0;
  --border-radius: 50%;
  --padding-top: 5px;
  --padding-bottom: 5px;
  --padding-start: 5px;
  --padding-end: 5px;
  height: auto;
}
.page .template_emails-push .push-list {
  margin: -8px -5px;
  padding-top: 5px;
}
.page .template_emails-push .push-list .select-all {
  margin-bottom: 7px;
}
.page .template_emails-push.mt-25 {
  margin-top: 25px;
}
.page.as-centered-column {
  margin: 0 auto;
  max-width: 1920px;
}

.border-danger {
  border-color: var(--app-danger) !important;
}

.input-error {
  position: static;
}

.card {
  border-radius: 10px;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 8px rgba(var(--app-cover-rgb), 0.15);
  cursor: pointer;
}
.card.selected {
  background-color: rgba(var(--app-main-softer-rgb), 0.25);
}
.card .card-btn {
  margin: 0;
  margin-top: 20px;
  font-weight: 600;
}
.card .card-img {
  margin: 0 auto;
  max-width: 75%;
  height: 50px;
}
.card .card-lbl {
  padding-top: 10px;
  color: var(--app-mid);
  font-weight: 500;
  text-align: center;
}
.card .card-sub-lbl {
  padding-top: 10px;
  color: var(--app-mid);
  text-align: center;
  font-size: 0.75rem;
}

.input-field-wrap.immagine {
  align-items: center !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/pages/desktop/common/car-fields/car-fields.page.scss","webpack://./src/theme/desktop/modal.scss"],"names":[],"mappings":"AAqIA;EACE;;;;;;;;;;GAAA;EAYA,0CAhJc;EAkJd,oBAAA;EACA,kBAlJa;EAoJb,UAAA;EAEA,kBAAA;ACxIF;;AD4JA;EAYE,0CAvLc;EAwLd,kBAAA;EAIC,oBAAA;EACD,kBAAA;ACvKF;;AD0KA;EAIE,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AC1KF;;ADgLA;EACE,8CA9Mc;EA+Mf,kBAAA;EAEA,aAAA;EACA,8BAAA;AC9KD;ADgLC;EACC,SAAA;EACE,gBAAA;AC9KJ;ADkLI;EACE,gBAAA;AChLN;ADoLC;EACC,eAAA;AClLF;;ADsLA;EACE,kBAAA;EACA,wCAAA;ACnLF;ADsLI;EACE,mBAAA;ACpLN;ADsLM;EACE,gBAAA;ACpLR;ADyLE;EACE,kBAAA;ACvLJ;;AD8LA;EACE,qBAAA;EAEA,sBAAA;AC5LF;;AD4NA;EACE,kBAAA;ACzNF;AD2NE;EACE,gBAAA;ACzNJ;AD6NE;EAwBE;;IAAA;AChPJ;AD0NI;EACE,uBAAA;ACxNN;AD4NI;EACE,yBAAA;AC1NN;AD6NI;EACE,0BAAA;AC3NN;AD+NI;EACE,sBAAA;AC7NN;ADgOI;EACE,6BAAA;AC9NN;ADqOI;EACE,6BAAA;ACnON;ADsOI;EACE,6BAAA;ACpON;ADwOI;EACE,2BAAA;ACtON;ADyOI;EACE,6BAAA;ACvON;AD0OI;EACE,+BAAA;ACxON;;AC9FA;EACC,uBFqBQ;AC4ET;AC3FC;EACC,aAAA;EAEA,uBAAA;AD4FF;AC1FE;EACC,SAAA;EACA,gBAAA;AD4FH;AC1FG;EACC,gBAAA;AD4FJ;ACxFI;EACC,kBAAA;AD0FL;ACpFE;EACC,gBAAA;ADsFH;ACjFC;EACC,iBAAA;ADmFF;AChFE;EACC,gBAAA;ADkFH;AC7EC;EACC,0BAAA;AD+EF;AC7EE;EAEC,gBAAA;AD8EH;AC5EG;EACC,yBAAA;AD8EJ;ACzEE;EACC,gBAAA;AD2EH;ACxEE;EACC,mBAAA;AD0EH;ACvEE;EACC,iBAAA;ADyEH;ACnEC;EACC,aAAA;EACA,uBAAA;ADqEF;AClEE;EACC,OAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;ADmEH;ACjEG;EACC,kBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;ADiEJ;AC7DG;EACC,OAAA;EACA,0CF9GY;AC6KhB;AC7DI;EACC,sBAAA;AD+DL;AC3DG;EACC,mBAAA;AD6DJ;ACxDE;EACC,gBAAA;AD0DH;ACxDE;EACC,gBAAA;AD0DH;ACrDC;EACC,aAAA;EACA,mBAAA;ADuDF;ACpDE;EAEC,gBAAA;ADqDH;ACnDG;EACC,iBAAA;ADqDJ;AClDG;EACC,gBAAA;ADoDJ;ACjDG;EAEC,eAAA;ADkDJ;ACvCG;EACC,eAAA;ADyCJ;ACtCG;EAEC,eAAA;ADuCJ;ACpCG;EACC,gBAAA;ADsCJ;ACpCG;EACC,gBAAA;ADsCJ;ACnCG;EACC,SAAA;ADqCJ;AChCE;EACC,iBAAA;EAGA,6BAAA;EAEA,eAAA;AD+BH;AC7BG;EACC,iBAAA;AD+BJ;AC7BG;EACC,iBAAA;AD+BJ;AC1BE;EACC,iBAAA;EAEA,oCAAA;EAEA,eAAA;EACA,gBAAA;AD0BH;ACtBE;EACC,sBAAA;EACA,uBAAA;ADwBH;ACtBG;EAGC,0BAAA;EACA,eAAA;EACA,gBAAA;ADsBJ;ACpBI;EACC,gBAAA;ADsBL;ACpBI;EACC,kBAAA;ADsBL;ACpBI;EACC,mBAAA;ADsBL;ACpBI;EACC,mBAAA;ADsBL;ACpBI;EACC,mBAAA;ADsBL;ACpBI;EACC,mBAAA;ADsBL;ACpBI;EACC,mBAAA;ADsBL;ACfE;EACC,mBAzOG;AD0PN;ACbE;EACC,gBAAA;ADeH;ACbE;EACC,kBAAA;ADeH;ACbE;EACC,mBAAA;ADeH;ACbE;EACC,mBAAA;ADeH;ACbE;EACC,mBAAA;ADeH;ACbE;EACC,mBAAA;ADeH;ACbE;EACC,mBAAA;ADeH;ACZE;EACC,gBAAA;ADcH;ACNC;EACC,aAAA;EACA,eAAA;ADQF;ACLE;EACC,oBAAA;ADOH;ACJI;EACC,iBAAA;ADML;ACCE;EACC,aAAA;EACA,6DAAA;EACA,cAAA;ADCH;AC4BE;EACC,qBAAA;AD1BH;AC8BE;EACC,mBAnUG;ADuSN;ACkCC;EAGC,mBAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;ADnCF;ACqCE;EACC,0BAAA;ADnCH;ACsCE;EACC,eAAA;ADpCH;ACsCE;EACC,eAAA;ADpCH;ACsCE;EACC,eAAA;ADpCH;ACsCE;EACC,eAAA;ADpCH;ACsCE;EACC,eAAA;ADpCH;ACsCE;EACC,eAAA;ADpCH;ACuCE;EACC,gBAAA;ADrCH;ACuCE;EACC,kBAAA;ADrCH;ACuCE;EACC,mBAAA;ADrCH;ACuCE;EACC,mBAAA;ADrCH;ACuCE;EACC,mBAAA;ADrCH;ACuCE;EACC,mBAAA;ADrCH;ACuCE;EACC,mBAAA;ADrCH;AC0CC;EACC,iBAAA;EAEA,aAAA;EACA,sCAAA;EACA,cAAA;EAGA,uBAAA;AD3CF;ACoDE;EACC,gBAAA;EACA,kBAAA;ADlDH;ACyDE;EACC,2BAAA;EACA,eALI;EAMJ,gBALI;ADlDP;AC0DE;EACC,0BAAA;EACA,eAXI;EAYJ,gBAXI;AD7CP;AC8DE;EACC,cAAA;EACA,cAAA;AD5DH;ACgEC;EACC,iBAAA;EAEA,aAAA;EACA,sCAAA;EACA,cAAA;AD/DF;AC2EE;EACC,aAAA;EACA,gBAAA;EACA,WAAA;EACA,0CAAA;ADzEH;AC6EE;EACC,mBAAA;EACA,gBAAA;EACA,eAAA;AD3EH;ACkFE;EACC,0BAAA;EACA,eALI;EAMJ,gBALI;AD3EP;ACmFE;EACC,sBAAA;EAEA,2BAAA;EACA,eAbI;EAcJ,gBAbI;ADrEP;ACwFE;EACC,SAAA;ADtFH;ACwFG;EACC,gBAAA;EACA,gBAAA;EACA,oBAAA;EAGA,qBAAA;EACA,mBAAA;EAEA,gBAAA;ADzFJ;ACqGC;EAEC,gBAAA;ADpGF;ACwGC;EACC,aAAA;EACA,mBAAA;ADtGF;ACwGE;EACC,kBAAA;EAEA,0BAAA;EACA,gBAAA;ADvGH;AC+GI;EACC,gBAAA;AD7GL;ACoHE;EACC,SAAA;EACA,iBAAA;EAEA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;ADtHH;ACwHG;EACC,eAAA;ADtHJ;AC+HC;EACC,aAAA;EACA,4DAAA;EACA,cAAA;AD7HF;ACkIE;EACC,aAAA;EACA,mBAAA;ADhIH;ACkIG;EAEC,kBAAA;ADjIJ;ACoIG;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;EAEA,cAAA;ADtIJ;AC6IE;EACC,iBAAA;AD3IH;AC6IG;EACC,aAAA;EACA,mBAAA;AD3IJ;AC6II;EACC,gBAAA;EACA,kBAAA;EAEA,0BAAA;EAGA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,kBAAA;AD/IL;ACqJI;EACC,SAAA;EACA,oBAAA;EAGA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;ADtJL;ACgKE;EACC,iBAAA;EACA,gBAAA;AD9JH;ACgKG;EACC,kBAAA;AD9JJ;ACkKE;EACC,gBAAA;ADhKH;ACsKC;EACC,cAAA;EACA,iBFtpBU;ACkfZ;;AA9fA;EACE,0CAAA;AAigBF;;AA7fA;EACE,gBAAA;AAggBF;;AA7fA;EACE,mBAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,sDDXU;ECYV,eAAA;AA8fF;AA5fE;EACE,wDAAA;AA8fJ;AA3fE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AA6fJ;AA1fE;EACE,cAAA;EACA,cAAA;EACA,YAAA;AA4fJ;AAzfE;EACE,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AA2fJ;AAxfE;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AA0fJ;;AApfE;EACE,8BAAA;AAufJ","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n\n@use \"../../../../../theme/desktop/modal\" as *;\n\n// Aggiunta Vigo\n.border-danger{\n  border-color: var(--app-danger)!important;\n}\n// Fine aggiunta Vigo\n\n.input-error{\n  position: static;\n}\n\n.card {\n  border-radius: 10px;\n  padding: 20px 15px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  box-shadow: $shadow-sm;\n  cursor: pointer;\n\n  &.selected{\n    background-color: rgba(var(--app-main-softer-rgb), .25);\n  }\n\n  .card-btn {\n    margin: 0;\n    margin-top: 20px;\n    font-weight: 600;\n  }\n\n  .card-img {\n    margin: 0 auto;\n    max-width: 75%;\n    height: 50px;\n  }\n\n  .card-lbl {\n    padding-top: 10px;\n    color: var(--app-mid);\n    font-weight: 500;\n    text-align: center;\n  }\n\n  .card-sub-lbl{\n    padding-top: 10px;\n    color: var(--app-mid);\n    text-align: center;\n    font-size: .75rem;\n  }\n\n}\n\n.input-field-wrap{\n  &.immagine{\n    align-items: center!important;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n\n@use \"desktop\" as *;\n@forward \"desktop\";\n\n\n\n\n\n.pg-header {\n\t@extend %modalHeader;\n}\n\n\n\n.page {\n\tpadding: $page_p;\n\n\t$mb: 20px;\n\n\n\n\t.btnbar {\n\t\tdisplay: flex;\n\t\t// align-items: center;\n\t\tjustify-content: center;\n\n\t\t.el-btn {\n\t\t\tmargin: 0;\n\t\t\tfont-weight: 600;\n\n\t\t\t&.mw-180 {\n\t\t\t\tmin-width: 180px;\n\t\t\t}\n\n\t\t\t&:not(:last-child) {\n\t\t\t\t&.mr-25 {\n\t\t\t\t\tmargin-right: 25px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t\t&.mt-40 {\n\t\t\tmargin-top: 40px;\n\t\t}\n\t}\n\n\n\t.checkboxes {\n\t\tpadding-top: 15px;\n\t\t// max-width: 350px;\n\n\t\t&.pt-5 {\n\t\t\tpadding-top: 5px;\n\t\t}\n\t}\n\n\n\t.description {\n\t\tcolor: var(--app-mid-dark);\n\n\t\t.b {\n\t\t\t// font-weight: 500;\n\t\t\tfont-weight: 600;\n\n\t\t\t&.uppercase {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\n\n\t\t&.lh-13 {\n\t\t\tline-height: 1.3;\n\t\t}\n\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\n\t\t&.pt-10 {\n\t\t\tpadding-top: 10px;\n\t\t}\n\n\t}\n\n\n\t.images-cart {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\t// align-items: center;\n\n\t\t.img-panel {\n\t\t\tflex: 1;\n\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n\n\t\t\t.ip-num {\n\t\t\t\tmargin-bottom: 5px;\n\n\t\t\t\tcolor: var(--app-main);\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\n\t\t\t.ip-img-wrap {\n\t\t\t\tflex: 1;\n\t\t\t\tborder: $borderDivider;\n\n\t\t\t\t.ip-img {\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tpadding-right: 30px;\n\t\t\t}\n\t\t}\n\n\n\t\t&.mt-20 {\n\t\t\tmargin-top: 20px;\n\t\t}\n\t\t&.mt-25 {\n\t\t\tmargin-top: 25px;\n\t\t}\n\t}\n\n\n\t.input-field-wrap {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\n\t\t.input-field {\n\t\t\t@extend %input;\n\t\t\tmax-width: 300px;\n\n\t\t\t&.ml-20 {\n\t\t\t\tmargin-left: 20px;\n\t\t\t}\n\n\t\t\t&.mxw-250 {\n\t\t\t\tmax-width: 250px;\n\t\t\t}\n\n\t\t\t&.mxv-100p,\n\t\t\t&.mxv100p {\n\t\t\t\tmax-width: 100%\n\t\t\t}\n\n\t\t\t// &.readonly {\n\t\t\t// \tborder: 0;\n\t\t\t// }\n\t\t}\n\n\t\t.input-field-lg {\n\t\t\t@extend %input-lg;\n\n\t\t\t&.fz-15 {\n\t\t\t\tfont-size: 15px;\n\t\t\t}\n\n\t\t\t&.mxv-100p,\n\t\t\t&.mxv100p {\n\t\t\t\tmax-width: 100%\n\t\t\t}\n\n\t\t\t&.mxw-300 {\n\t\t\t\tmax-width: 300px;\n\t\t\t}\n\t\t\t&.mxw-350 {\n\t\t\t\tmax-width: 350px;\n\t\t\t}\n\n\t\t\t&.readonly {\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t}\n\n\n\t\t.input-help {\n\t\t\tmargin-left: 12px;\n\n\t\t\t// color: rgba(var(--app-main-softer-rgb), .7);\n\t\t\tcolor: var(--app-main-softer);\n\n\t\t\tfont-size: 22px;\n\n\t\t\t&.ml-15 {\n\t\t\t\tmargin-left: 15px;\n\t\t\t}\n\t\t\t&.ml-20 {\n\t\t\t\tmargin-left: 20px;\n\t\t\t}\n\t\t}\n\n\n\t\t.input-unit {\n\t\t\tmargin-left: 12px;\n\n\t\t\tcolor: rgba(var(--app-mid-rgb), .7);\n\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t}\n\n\n\t\t&.w-stacked-lbl {\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\n\t\t\t.input-field-lbl {\n\t\t\t\t@extend %longWord;\n\n\t\t\t\tcolor: var(--app-mid-dark);\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\t&.mb-0 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t&.mb-5 {\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\t&.mb-10 {\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t}\n\t\t\t\t&.mb-15 {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t\t&.mb-20 {\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t\t&.mb-25 {\n\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t}\n\t\t\t\t&.mb-30 {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: $mb;\n\t\t}\n\n\t\t// ? can this be done better w/ Sass syntax?\n\t\t&.mb-0 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t&.mb-5 {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t&.mb-10 {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t\t&.mb-15 {\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t&.mb-25 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t\t&.mb-30 {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\n\t\t&.mxw-350 {\n\t\t\tmax-width: 350px;\n\t\t}\n\n\t}\n\n\n\t// copied from modal_alarm.scss\n\t// renamed from .input-fields to avoid name collision\n\t.input-fields-vModal_alarm {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\n\t\t&.input-fields--check {\n\t\t\tmargin: -8px -10px 0;\n\n\t\t\t.input-field {\n\t\t\t\t&.special {\n\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t&.input-fields--text {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(auto, 250px));\n\t\t\tgap: 10px 30px;\n\n\t\t\t.input-field {\n\t\t\t\t// &.input-field--text {\n\n\t\t\t\t// --background\tBackground of the input\n\t\t\t\t// --color\tColor of the input text\n\t\t\t\t// --padding-bottom\tBottom padding of the input\n\t\t\t\t// --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n\t\t\t\t// --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n\t\t\t\t// --padding-top\tTop padding of the input\n\t\t\t\t// --placeholder-color\tColor of the input placeholder text\n\t\t\t\t// --placeholder-font-style\tFont style of the input placeholder text\n\t\t\t\t// --placeholder-font-weight\tFont weight of the input placeholder text\n\t\t\t\t// --placeholder-opacity\tOpacity of the input placeholder text\n\n\t\t\t\t@extend %input;\n\n\n\t\t\t\t// }\n\n\t\t\t\t// &.input-field--poi {\n\t\t\t\t// \tcursor: pointer;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t}\n\n\n\t\t&.input-fields--toggle {\n\t\t\tmargin: -10px -#{$page_px} 0;\n\t\t}\n\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: $mb;\n\t\t}\n\n\t}\n\n\n\t.input-lbl {\n\t\t@extend %longWord;\n\n\t\tmargin-bottom: 15px;\n\n\t\tcolor: var(--app-mid);\n\t\tfont-size: 18px;\n\t\tfont-weight: 500;\n\n\t\t&.input-lbl--mid-dark {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t}\n\n\t\t&.fz-14 {\n\t\t\tfont-size: 14px;\n\t\t}\n\t\t&.fz-15 {\n\t\t\tfont-size: 15px;\n\t\t}\n\t\t&.fz-16 {\n\t\t\tfont-size: 16px;\n\t\t}\n\t\t&.fz-17 {\n\t\t\tfont-size: 17px;\n\t\t}\n\t\t&.fz-19 {\n\t\t\tfont-size: 19px;\n\t\t}\n\t\t&.fz-20 {\n\t\t\tfont-size: 20px;\n\t\t}\n\n\t\t&.mb-0 {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t&.mb-5 {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t&.mb-10 {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t\t&.mb-15 {\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\t&.mb-20 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t\t&.mb-25 {\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t\t&.mb-30 {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\n\n\t.recap-grid {\n\t\tpadding-top: 30px;\n\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, auto);\n\t\tgap: 12px 25px;\n\n\t\t// spacing of all elems relative to the container\n\t\tjustify-content: center;\n\t\t// align-content: flex-start;\n\t\t// min-height: 100%;\n\n\t\t// handle spacing inside elems\n    // align-items: center;\n\t\t// justify-items: center;\n\n\n\t\t.input-lbl {\n\t\t\tgrid-column: 1/3;\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\n\t\t$fz: 17px;\n\t\t$fw: 500;\n\n\t\t.output-lbl {\n\t\t\tcolor: var(--app-mid-light);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\t\t}\n\n\t\t.output-val {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t\t@extend %longWord;\n\t\t}\n\n\n\t\t&.mw-75p {\n\t\t\tmargin: 0 auto;\n\t\t\tmax-width: 75%;\n\t\t}\n\t}\n\n\t.recap-grid-type2 {\n\t\tpadding-top: 30px;\n\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, auto);\n\t\tgap: 12px 25px;\n\n\t\t// spacing of all elems relative to the container\n\t\t// justify-content: center;\n\t\t// align-content: flex-start;\n\t\t// min-height: 100%;\n\n\t\t// handle spacing inside elems\n    // align-items: center;\n\t\t// justify-items: space-between;\n\n\n\t\t.hr {\n\t\t\tmargin: 5px 0;\n\t\t\tgrid-column: 1/3;\n\t\t\theight: 1px;\n\t\t\tbackground-color: var(--app-mid-lighter-2);\n\t\t}\n\n\n\t\t.input-lbl {\n\t\t\tmargin-bottom: 20px;\n\t\t\tgrid-column: 1/3;\n\t\t\tfont-size: 16px;\n\t\t}\n\n\t\t// ero qui\n\t\t$fz: 15px;\n\t\t$fw: 500;\n\n\t\t.output-lbl {\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\t\t}\n\n\t\t.output-val {\n\t\t\tjustify-self: flex-end;\n\n\t\t\tcolor: var(--app-mid-light);\n\t\t\tfont-size: $fz;\n\t\t\tfont-weight: $fw;\n\n\t\t\t@extend %longWord;\n\t\t}\n\n\n\t\t.rg-btn {\n\t\t\tmargin: 0;\n\n\t\t\t&.rg-btn--confirm {\n\t\t\t\tmargin-top: 30px;\n\t\t\t\tgrid-column: 1/3;\n\t\t\t\tjustify-self: center;\n\n\t\t\t\t$p: 25px;\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\n\t\t// &.mw-75p {\n\t\t// \tmargin: 0 auto;\n\t\t// \tmax-width: 75%;\n\t\t// }\n\t}\n\n\n\t.searchbar {\n\t\t@extend %search;\n\t\tmax-width: 350px;\n\t}\n\n\n\t.select-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.sp-lbl {\n\t\t\tmargin-right: 20px;\n\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-weight: 500;\n\t\t}\n\n\n\t\t.sp-input {\n\t\t\t// width: ;\n\n\t\t\t&.mxw- {\n\t\t\t\t&150 {\n\t\t\t\t\tmax-width: 150px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t.sp-btn {\n\t\t\tmargin: 0;\n\t\t\tmargin-left: 12px;\n\n\t\t\t--border-radius: 50%;\n\n\t\t\t$p: 6px;\n\t\t\t--padding-top: #{$p};\n\t\t\t--padding-bottom: #{$p};\n\t\t\t--padding-start: #{$p};\n\t\t\t--padding-end: #{$p};\n\n\t\t\theight: auto;\n\n\t\t\t.btn-icon {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\n\t}\n\n\n\t// copied from modal_alarm.scss\n\t// (look for: &.page-3)\n\t.template_emails-push {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(auto-fit, minmax(300px, auto));\n\t\tgap: 25px 40px;\n\n\t\t// .col {}\n\n\n\t\t.input-email {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.input-field {\n\t\t\t\t@extend %input;\n\t\t\t\tmargin-right: 12px;\n\t\t\t}\n\n\t\t\t.btn-add {\n\t\t\t\tmargin: 0;\n\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t$p: 8px;\n\t\t\t\t--padding-top: #{$p};\n\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\theight: auto;\n\n\t\t\t\tfont-size: 9px;\n\n\t\t\t\t// .btn-icon {}\n\t\t\t}\n\t\t}\n\n\n\t\t.emails {\n\t\t\tpadding-top: 10px;\n\n\t\t\t.email {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.text {\n\t\t\t\t\tmargin-top: -1px;\n\t\t\t\t\tmargin-right: 15px;\n\n\t\t\t\t\tcolor: var(--app-mid-dark);\n\n\t\t\t\t\t$lh: 20px;\n\t\t\t\t\tfont-size: 17px;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\tmax-height: calc(2 * #{$lh});\n\t\t\t\t\toverflow-y: hidden;\n\n\t\t\t\t\t// @extend %oneLiner;\n\t\t\t\t\t@extend %longWord;\n\t\t\t\t}\n\n\t\t\t\t.btn-close {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t--border-radius: 50%;\n\n\t\t\t\t\t$p: 5px;\n\t\t\t\t\t--padding-top: #{$p};\n\t\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t\theight: auto;\n\n\t\t\t\t\t// .btn-icon {}\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t}\n\n\n\t\t.push-list {\n\t\t\tmargin: -8px -5px;\n\t\t\tpadding-top: 5px;\n\n\t\t\t.select-all {\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t}\n\t\t}\n\n\t\t&.mt-25 {\n\t\t\tmargin-top: 25px;\n\t\t}\n\t}\n\n\n\n\t&.as-centered-column {\n\t\tmargin: 0 auto;\n\t\tmax-width: $page_maxW;\n\t}\n\n\n}\n\n\n\n.pg-footer {\n\t@extend %modalFooter;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
